<template>
  <div class="exp-container">
    <div class="exp-head">Explore adventures and activities</div>
    <div class="exp-content">
      <div v-for="activity in activities" :key="activity.id" class="exp-item-wrapper">
        <div class="exp-item-image" data-parallax="0.15">
          <img :src="activity.image" :alt="activity.title"/>
        </div>
        <div class="exp-item">
          <div class="exp-item__title">{{ activity.title }}</div>
          <div class="exp-item__desc">{{ activity.desc }}</div>
          <router-link :to="activity.cta.link" class="exp-item__cta">{{ activity.cta.text }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ExploreAdventure",
  data() {
    return {
      activities: [
        {
          id: 1,
          title: "Fitness & Sport",
          desc: "Partnered with trusted industry professionals, these active sessions are designed to challenge, energize, and build lasting stamina.  Power through high-intensity workouts or enjoy casual, beginner-friendly activities made for moving together with friends and family.",
          image: require('@/assets/images/fitness-and-sport.jpg'),
          cta: {
            text: "Explore Fitness & Sport",
            link: "/events/fitness-and-sport",
          }
        },
        {
          id: 2,
          title: "Outdoor & Trail",
          desc: "Led by on-the-ground experts and local guides, these outdoor experiences bring communities together and inspire exploration one trail at a time. Gear up to summit peaks, navigate regional landmarks, or set up camp in nature’s playground.",
          image: require('@/assets/images/outdoor-and-trail.jpg'),
          cta: {
            text: "Explore Outdoor & Trail",
            link: "/events/outdoor-and-trail",
          }
        },
        {
          id: 3,
          title: "Wellness & Recovery",
          desc: "Designed by certified specialists and recovery clinics, these restorative sessions offer a holistic space to unwind and recharge. Engage in physical therapy and targeted treatments to soothe muscles, improve mobility, and accelerate healing.",
          image: require('@/assets/images/wellness-and-recovery.jpg'),
          cta: {
            text: "Explore Wellness & Recovery",
            link: "/events/wellness-and-recovery",
          }
        },
      ],
    };
  },
  methods: {},
};
</script>
<style scoped lang="scss">
.exp-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-inline: 20px;
  .exp-head {
    text-align: left;
    font-family: 'Berthold Akzidenz Grotesk Medium';
    font-size: 2em;
    color: $blue-head;
    margin-bottom: 40px;
    line-height: normal;
  }
  .exp-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 40px;
  }
}
.exp-item-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.exp-item-image {
  flex: 1;
  background: $secondary-color-20;
  aspect-ratio: 3/2;
  border-radius: 16px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transform: scale(1.2);
    will-change: transform;
  }
}
@media (prefers-reduced-motion: reduce) {
  .exp-item-image img {
    transform: none;
  }
}
.exp-item {
  flex: 2;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 20px;
  &__title {
    font-family: 'Berthold Akzidenz Grotesk Medium';
    font-size: 1.5em;
    text-transform: uppercase;
    text-align: left;
  }
  &__desc {
    color: $secondary-color-60;
    display: block;
    font-size: 16px;
    text-align: justify;
  }
  &__cta {
    background: $green-dark;
    color: $white;
    padding-inline: 32px;
    padding-block: 8px;
    border-radius: 24px;
    text-decoration: none;
    outline: none;
    font-family: "Berthold Akzidenz Grotesk Medium";
    cursor: pointer;
  }
}
@media (min-width: 672px) {
  .exp-container {
    .exp-content {
      gap: 20px;
    }
  }
  .exp-item-wrapper {
    flex-direction: row;
    justify-content: space-between;
  }
  .exp-item {
    &__title {
      margin-top: 32px;
    }
    &__desc {
      max-width: 600px;
      margin-bottom: 20px;
    }
  }
}
@media (min-width: 672px) and (max-width: 1024px) {
  .exp-container {
    .exp-content {
      gap: 40px !important;
    }
  }
  .exp-item-wrapper {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .exp-item {
    &__title {
      margin-top: 0 !important;
    }
    &__desc {
      max-width: 100% !important;
      margin-bottom: 0 !important;
    }
  }
}
</style>